export function asError(thrown: unknown): Error {
    return thrown instanceof Error
        ? thrown
        : typeof thrown === "string"
        ? new Error(thrown)
        : typeof thrown === "object" && thrown !== null && "message" in thrown
        ? new Error((thrown as any).message)
        : new Error(`unknown error: ${thrown}`)
}
